//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useCallback,
  useEffect,
  Fragment,
  useContext,
} from "react";
import * as moment from "moment";
import { toast } from "react-toastify";
import { PDFDownloadLink } from "@react-pdf/renderer";

// custom pages
import { styles } from "./styles";
import report from "apis/Report/Report";
import CiprianReportPDF from "./CiprianReportPDF";
import YetToBeDeactivationReportXLSX from "./YetToBeDeactivationReportXLSX";
import Context from "context/context";
import useDebounce from "helpers/useDebounce";

// material-ui
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from "@material-ui/lab/Autocomplete";

// material-ui icons
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useTranslation } from 'react-i18next';
import { enUS, fr } from "date-fns/locale";
import { withStyles } from "@material-ui/core/styles";
import { parse, format } from 'date-fns';
import { CSVLink } from "react-csv";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import NoData from "components/Table/NoData";
import Loader from "components/Loader/Loader";
// material-ui icons
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import {dateFormat} from "helpers/dataFormat"

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);
export default function YetToBeDeactivation(props) {
  const { state, dispatch } = useContext(Context);
  const { page, setDisableDropdown} = props;
  const { searchLoyaltyAPI, YetToBeDeactivationReportAPI } = report();
  const classes = styles();
  const { t, i18n } = useTranslation()
  const [states, setstates] = useState({
    columns: [],
    dialog: false,
    data: [],
    excelData: {},
    pdfData: {},
    response: false,
    startDate: new Date(),
    endDate: new Date(),
    dateApplied: false,
    type: "All",
    eLoading: false,
    pLoading: false,
    searchValue: "",
    searchData: [],
    searchLoading: false,
    loyaltyAccount: [],
    excelBtnActive: false,
    pdfBtnActive: false,
  });
const[data,setData]=useState([])
const[coulmns,setCoulmns]=useState([])
  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);
  
  const {
    searchLoading,
    searchData,
    searchValue,
    loyaltyAccount,
    excelBtnActive,
    pdfBtnActive,
    rollingMonth
  } = states;

  const searchValueDebounce = useDebounce(searchValue);
 


  // handleSearch api func
  const handleSearch = async () => {
    setStates({ searchLoading: true });
    try {
      let values;
      values = {
        loyaltyId: searchValue,
      };

      let res = await searchLoyaltyAPI(values);
      if (res) {
        setStates({ searchData: res?.data, searchLoading: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // CustomerStatus api func
  const handleGetCustomerStatus = async (type) => {
    try {
      setDisableDropdown(true);
      let values = {};
      if (states.startDate=="Invalid Date"||states.endDate=="Invalid Date" || states?.startDate2 =="Invalid Date" ||states.endDate2=="Invalid Date" ) {
        toast.error("Invalid Date Format", {
          toastId: "update-error",
        });
        setStates({
          response: true,
          eLoading: false,
          pLoading:false
        });
      setDisableDropdown(true);

        return;
      }
      values = {
        startDate: moment(states.startDate).format("MM/DD/YYYY"),
        endDate: moment(states.endDate).format("MM/DD/YYYY"),
      };
    
      let res = await YetToBeDeactivationReportAPI(values);  
      if (res && res?.data.ciprian.length>0) {

        dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
        if (type === "excel") {          
 
          const today = new Date().toLocaleDateString();
          
  
          const headerRow = ['Report Date', today]; // First row with "Report Date" in the first column and its value in the second column
          const headerRow1 = ['Date Range Pulled', moment(states.startDate).format("MM/DD/YYYY"), moment(states.endDate).format("MM/DD/YYYY")]; // First row with "Report Date" in the first column and its value in the second column
         
          let coulumns =Object.entries(res?.data?.ciprian[0]).map((obj)=>{return obj[0]?obj[0]:""})
         setCoulmns(coulumns)
          const csvData = [headerRow,headerRow1,coulumns]; 
  
          const row = res?.data?.ciprian.forEach((item, index) => {
            
                const rowData = Object.values(item)// Extracting values excluding the "Report Date" value
                csvData.push(rowData);
               
            // }
        });
setData(csvData)

        
setStates({
  data:res?.data?.ciprian,
  excelData:res?.data,
  response: true,
  pLoading:false,
  eLoading: false
});
        } 
        
        setDisableDropdown(false);
        return true;
      }
      else if(res && res?.data.ciprian.length==0) {
        dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
        setStates({
          response: true,
          eLoading: false,
          pLoading:false
        });        
        toast.success(t("No Data Found"), {
          toastId: "no-Data",
        });
        setDisableDropdown(false);
        return false;
         

      }
      else
        {
          dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
          setStates({
            response: true,
            eLoading: false,
          });        
          toast.error(t(res?.message?res?.message:"Something went wrong in reports..!"), {
            toastId: "no-Data",
          });
          setDisableDropdown(false);
          return false;
      
      }
    } 
    catch (err) {
      console.log(err);
    }
  };

  const locale = i18n.language == 'fr' ? fr : enUS;

  return (
    <div>
   
   <div className={classes.headText}>
        {t('Select date range')}{" "}
        {states.dateApplied && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                if (pdfBtnActive) {
                  setStates({
                    pdfBtnActive: false,
                    dateApplied: false,
                    startDate: new Date(),
                    endDate: new Date(),
                  });
                }
                setStates({
                  dateApplied: false,
                  startDate: new Date(),
                  endDate: new Date(),
                });
              }}
            >
              {t('Remove')}
            </span>
          </React.Fragment>
        )}
      </div>
      <div className={classes.inputsDiv}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>

              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("Start Date")}
                id="date-picker-inline"
                className={classes.dateInput}
                value={states.startDate}
                // maxDate={new Date()}
                minDate={new Date()}
                onChange={(date) => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                    });
                  }

                    if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(states.endDate).format("MM/DD/YYYY"))) {
                      toast.error("Start date should be less than End date.", {
                        toastId: "start-date-end-date",
                      });
                      setStates({ startDate: null });
                      return;
                    }
                    if (moment(moment(date).format("MM/DD/YYYY")).isBefore(moment(new Date()).format("MM/DD/YYYY"))) {
                      toast.error("This report only accepts future dates for selection. ", {
                        toastId: "start-date-end-date",
                      });
                      setStates({ startDate: null });
                      return;
                    }
                  
                  setStates({ startDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("End Date")}
                id="date-picker-inline2"
                className={classes.dateInput}
                value={states.endDate}
                // maxDate={new Date()}
                minDate={new Date()}
                onChange={(date) => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                    });
                  }
                  if (moment(moment(date).format("MM/DD/YYYY")).isBefore(moment(states.startDate).format("MM/DD/YYYY"))) {
                    toast.error("End date should be greater than Start date.", {
                      toastId: "start-date-end-date",
                    });
                    setStates({ endDate: null });
                    return;
                  } 
                  if (moment(moment(date).format("MM/DD/YYYY")).isBefore(moment(new Date()).format("MM/DD/YYYY"))) {
                    toast.error("This report only accepts future dates for selection.", {
                      toastId: "start-date-end-date",
                    });
                    setStates({ endDate: null });
                    return;
                  }
                  setStates({ endDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </div>
      
      <div className={classes.exportAndPreview}>
      {/* <Button
          className={classes.previewBtn}
          onClick={async () => {
        
         
            if (
              (states?.startDate && !states.endDate) ||
              (!states?.startDate && states.endDate) ||
              (!states?.startDate && !states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
      
          if (
            states?.startDate?.toString() === "Invalid Date" &&
            states?.endDate?.toString() === "Invalid Date"
          ) {
            toast.error("Invalid date.", {
              toastId: "invalid-date",
            });
            setStates({ startDate: new Date(), endDate: new Date() });
            return;
          } else if (states?.startDate?.toString() === "Invalid Date") {
            toast.error("Invalid start date.", {
              toastId: "invalid-s-date",
            });
            setStates({ startDate: new Date() });
            return;
          } else if (states.endDate?.toString() === "Invalid Date") {
            toast.error("Invalid end date.", {
              toastId: "invalid-e-date",
            });
            setStates({ endDate: new Date() });
            return;
          }

          setStates({
            response: false,
            excelData: [],
            pLoading: true,
            excelBtnActive: true,
            pdfBtnActive: false,
          });
          let res = await handleGetCustomerStatus("excel");
          if (res) {
            setStates({ dialog: true });
          }
        }}
          disabled={states.pLoading || states.eLoading}
        >
          {states.pLoading ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25 }}
                variant="determinate"
                value={state.reportResCount}
              />{" "}
              &nbsp;
              <span style={{ color: "#305698", fontWeight: "bold" }}>
                {state.reportResCount == 0 ?
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-p"></div>
                    </div>
                  </div> : `${state.reportResCount}%`}
              </span>
            </React.Fragment>
          ) : (
            t("Preview")
          )}
        </Button> */}
        <Button
          className={classes.exportBtn}
          onClick={async () => {
            setStates({
              response: false,
              excelData: [],
              eLoading: true,
              excelBtnActive: true,
              pdfBtnActive: false,
            });
            let res = await handleGetCustomerStatus("excel");
            if (res) {
              document.getElementById("csv").click();
            }
          }}
          disabled={states.eLoading || states.pLoading}
        >
          {states.eLoading ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25 }}
                variant="determinate"
                value={state.reportResCount}
              />{" "}
              &nbsp;
              <span style={{ color: "#305698", fontWeight: "bold" }}>
                {state.reportResCount == 0 ? (
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-e"></div>
                    </div>
                  </div>
                ) : (
                  `${state.reportResCount}%`
                )}
              </span>
            </React.Fragment>
          ) : (
            t("Export")
          )}
        </Button>
        {(states.eLoading || states.pLoading) && <div style={{ color: 'red', marginLeft: 10 }}>*Please wait don't reload the page, system is processing</div>}
        {/* <YetToBeDeactivationReportXLSX
          states={states}
          date={
            moment(moment(states?.startDate).format("MM/DD/YYYY")).isSame(
              moment(states?.endDate).format("MM/DD/YYYY")
            )
              ? `${moment(states?.startDate).format("MM/DD/YYYY")}`
              : `${moment(states?.startDate).format(
                "MM/DD/YYYY"
              )} - ${moment(states?.endDate).format("MM/DD/YYYY")}`
          }
          page={page}
        /> */}
           <CSVLink
        id="csv"
        data={data}
        // headers={coulmns}
        skipEmptyLines={true}
        filename={
          `${page}`+"-"+moment(new Date()).format("YYYYMMDD")+ ".csv"
        }
        className={classes.CSVlink}
      />
       <Dialog
        onClose={() => {
          setStates({ dialog: false });
        }}
        aria-labelledby="simple-dialog-title"
        open={states.dialog}
        fullWidth
        maxWidth='lg'

      >
        <div className={classes.mainDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} className={classes.gridOne}>
              {page + " " + "Report"}
              <HighlightOffIcon
                className={classes.gridTwo}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              />
            </Grid>
            <Grid item xs={12} className={classes.gridFive}>
              <span className={classes.gridThreeSpan}>{t('Generated Date')} : </span>
              <span>{dateFormat(moment(new Date()).format("MM-DD-YYYY"), i18n.language)}</span>
            </Grid>
          </Grid>
          {states.response ? (
            states.data && states.data.length > 0 ? (
              <TableContainer className={classes.tableContainer}>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                  aria-label="enhanced table"
                >
                  <TableHead className={classes.tableHead}>
                    <TableRow>
                      {coulmns?.map((h, i) => (
                        <TableCell key={i} className={classes.tableHeading}>
                          <div
                            className={
                              (states.groupBy === "loyalty_id" &&
                                h === "Loyalty ID") ||
                                (states.groupBy ===
                                  "customer_billto_account_number" &&
                                  h == "Bill to Account ID")
                                ? classes.groupByMarker
                                : classes.noDisplay
                            }
                          >{`( ${t('Sort by')} )`}</div>
                          <div>{t(h)}</div>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {states.data?.slice(0, 10)?.map((p, i) => (
                      <TableRow role="checkbox" tabIndex={-1} key={i}>
                        {coulmns.map((s) => (
                          <TableCell align="left" className={classes.rowCell}>
                            {t(p?.[s])}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <NoData />
            )
          ) : (
            <Loader Loading={!states?.response}></Loader>
          )}
        </div>
        {states.data && states.data.length > 0 && (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.gridFour}>
              <Button
                className={classes.previewBtn}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              >
                {t('Cancel')}
              </Button>
              <Button
                className={classes.exportBtn}
                onClick={() => {
                  setStates({ dialog: false });
                  document.getElementById("csv").click();
                }}
              >
                {t('Export CSV')}
              </Button>
            </Grid>
          </Grid>
        )}
      </Dialog>
      </div>
    </div>
  );
}
